import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { DocumentStoreService } from '../../../services/documents/document-store.service';
import { MatterService } from '../../../services/matters/matter.service';
import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-matter-info',
  templateUrl: './matter-info.component.html',
  styleUrls: ['./matter-info.component.css'],
})
export class MatterInfoComponent implements OnInit {
  /**
   * Matter info object for view
   */
  @Input() matter_info: any = {};

  /**
   * Emits event when Status tab is to be shown
   * @param {EventEmitter<string> = new EventEmitter<string>(} ) openStatus Event Emitter
   */
  @Output() openStatus: EventEmitter<string> = new EventEmitter<string>();

  /**
   * Donation Report document id and name
   * @type {any}
   */
  donationReportDocument: any;

  /**
   * Processing donation report
   * @type {boolean}
   */
  processingDonationReport: boolean = false;

  constructor(private documentStoreService: DocumentStoreService, private matterService: MatterService, private notyService: NotyService) {}

  ngOnInit() {}

  // Component methods

  /**
   * Creates donation report
   */
  createDonationReport() {
    this.processingDonationReport = true;
    this.matterService
      .donationReport(this.matter_info.id)
      .then((response_json) => {
        this.processingDonationReport = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Donation Report creation successful', 'success');
          this.donationReportDocument = {
            id: response_json.donation_report_document_id,
            name: response_json.name,
          };
          if (this.documentStoreService.matterDocumentsListComponent) this.documentStoreService.matterDocumentsListComponent.loadDocuments();
        } else this.notyService.notify(response_json.text || 'Error processing donation report', 'error');
      })
      .catch(() => {
        this.processingDonationReport = false;
        this.notyService.notify('Error processing donation report', 'error');
      });
  }
}
